import axios from 'axios';
import type { AxiosResponse } from 'axios';

import type { FormData } from 'types/formData';

export interface CreateReportRequestBody {
  doctorId: string | number;
  pacientId?: number;
  pacientData: {
    name: string;
    age: number;
    sex: string;
    color: string;
    maritalStatus: string;
    weight: string;
    height: string;
    educationDegree: string;
    profession: string;
    address: string;
    cellphone: string;
    consultationDate: Date;
    consultatedBy: string;
    reasonForConsultation: string;
    followUp: string;
  };
  clinicalData: FormData['clinicalData'];
  clinicalPhysicalExamData: FormData['clinicalPhysicalExamData'];
  avaliationData: FormData['avaliationData'];
  treatmentData: FormData['treatmentData'];
}

export function buildCreateReportRequestBody(
  merged: FormData,
  doctorId: string | number,
  options?: { pacientId?: string | number | null },
): CreateReportRequestBody {
  const body: CreateReportRequestBody = {
    doctorId,
    pacientData: {
      ...merged.pacientData,
      age: Number(merged.pacientData.age),
      consultationDate: new Date(merged.pacientData.consultationDate),
    },
    clinicalData: merged.clinicalData,
    clinicalPhysicalExamData: merged.clinicalPhysicalExamData,
    avaliationData: merged.avaliationData,
    treatmentData: merged.treatmentData,
  };

  if (
    options?.pacientId !== undefined &&
    options?.pacientId !== null &&
    options.pacientId !== ''
  ) {
    body.pacientId = Number(options.pacientId);
  }

  return body;
}

export type CreateReportResponse = {
  user: { email: string; password: string };
};

export function postCreateReport(
  merged: FormData,
  doctorId: string | number,
  options?: { pacientId?: string | number | null },
): Promise<AxiosResponse<CreateReportResponse>> {
  const payload = buildCreateReportRequestBody(merged, doctorId, options);
  return axios.post<CreateReportResponse>('create-report', payload);
}
